<template>
    <div
        v-if="average && total && total > 4"
        class="product-rating-title d-flex align-center"
        :class="{
            'justify-center': compact
        }"
    >
        <v-rating
            :model-value="average"
            name="rating"
            color="secondary"
            size="small"
            density="compact"
            half-increments
            readonly
        ></v-rating>
        <div
            class="font-size-7 ml-1"
        >
            {{ total }} Review<template v-if="total > 1">s</template>
        </div>
    </div>
</template>

<script lang="ts" setup>
    withDefaults(
        defineProps<{
            average: Nilish<number>;
            total: Nilish<number>;
            compact?: boolean;
        }>(),
        {
            compact: false
        }
    );
</script>

<style lang="scss"></style>
